/* tslint:disable */
/* eslint-disable */
/**
 * Cerebral Machines API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { LeadMagnetCreate } from '../models';
// @ts-ignore
import type { LeadMagnetUpdate } from '../models';
// @ts-ignore
import type { ValidationErrorModel } from '../models';
/**
 * LeadMagnetApi - axios parameter creator
 */
export const LeadMagnetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new lead magnet
         * @param {LeadMagnetCreate} leadMagnetCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadMagnetCreatePost: async (leadMagnetCreate: LeadMagnetCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadMagnetCreate' is not null or undefined
            assertParamExists('leadMagnetCreatePost', 'leadMagnetCreate', leadMagnetCreate)
            const localVarPath = `/api/lead-magnets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadMagnetCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a lead magnet by ID
         * @param {string} leadMagnetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadMagnetDeleteLeadMagnetIdDelete: async (leadMagnetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadMagnetId' is not null or undefined
            assertParamExists('leadMagnetDeleteLeadMagnetIdDelete', 'leadMagnetId', leadMagnetId)
            const localVarPath = `/api/lead-magnets/{lead_magnet_id}`
                .replace(`{${"lead_magnet_id"}}`, encodeURIComponent(String(leadMagnetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a lead magnet by ID
         * @param {string} leadMagnetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadMagnetGetLeadMagnetIdGet: async (leadMagnetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadMagnetId' is not null or undefined
            assertParamExists('leadMagnetGetLeadMagnetIdGet', 'leadMagnetId', leadMagnetId)
            const localVarPath = `/api/lead-magnets/{lead_magnet_id}`
                .replace(`{${"lead_magnet_id"}}`, encodeURIComponent(String(leadMagnetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all lead magnets
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {string | null} [createdBy] 
         * @param {string | null} [assetId] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadMagnetListGet: async (search?: string | null, status?: string | null, createdBy?: string | null, assetId?: string | null, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lead-magnets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['created_by'] = createdBy;
            }

            if (assetId !== undefined) {
                localVarQueryParameter['asset_id'] = assetId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a lead magnet by ID
         * @param {string} leadMagnetId 
         * @param {LeadMagnetUpdate} leadMagnetUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadMagnetUpdateLeadMagnetIdPut: async (leadMagnetId: string, leadMagnetUpdate: LeadMagnetUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadMagnetId' is not null or undefined
            assertParamExists('leadMagnetUpdateLeadMagnetIdPut', 'leadMagnetId', leadMagnetId)
            // verify required parameter 'leadMagnetUpdate' is not null or undefined
            assertParamExists('leadMagnetUpdateLeadMagnetIdPut', 'leadMagnetUpdate', leadMagnetUpdate)
            const localVarPath = `/api/lead-magnets/{lead_magnet_id}`
                .replace(`{${"lead_magnet_id"}}`, encodeURIComponent(String(leadMagnetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadMagnetUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeadMagnetApi - functional programming interface
 */
export const LeadMagnetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeadMagnetApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new lead magnet
         * @param {LeadMagnetCreate} leadMagnetCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadMagnetCreatePost(leadMagnetCreate: LeadMagnetCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadMagnetCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadMagnetCreatePost(leadMagnetCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadMagnetApi.leadMagnetCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a lead magnet by ID
         * @param {string} leadMagnetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadMagnetDeleteLeadMagnetIdDelete(leadMagnetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadMagnetDeleteLeadMagnetIdDelete(leadMagnetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadMagnetApi.leadMagnetDeleteLeadMagnetIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a lead magnet by ID
         * @param {string} leadMagnetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadMagnetGetLeadMagnetIdGet(leadMagnetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadMagnetGetLeadMagnetIdGet(leadMagnetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadMagnetApi.leadMagnetGetLeadMagnetIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all lead magnets
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {string | null} [createdBy] 
         * @param {string | null} [assetId] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadMagnetListGet(search?: string | null, status?: string | null, createdBy?: string | null, assetId?: string | null, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadMagnetListGet(search, status, createdBy, assetId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadMagnetApi.leadMagnetListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a lead magnet by ID
         * @param {string} leadMagnetId 
         * @param {LeadMagnetUpdate} leadMagnetUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadMagnetUpdateLeadMagnetIdPut(leadMagnetId: string, leadMagnetUpdate: LeadMagnetUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadMagnetUpdateLeadMagnetIdPut(leadMagnetId, leadMagnetUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadMagnetApi.leadMagnetUpdateLeadMagnetIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LeadMagnetApi - factory interface
 */
export const LeadMagnetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeadMagnetApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new lead magnet
         * @param {LeadMagnetApiLeadMagnetCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadMagnetCreatePost(requestParameters: LeadMagnetApiLeadMagnetCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeadMagnetCreate> {
            return localVarFp.leadMagnetCreatePost(requestParameters.leadMagnetCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a lead magnet by ID
         * @param {LeadMagnetApiLeadMagnetDeleteLeadMagnetIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadMagnetDeleteLeadMagnetIdDelete(requestParameters: LeadMagnetApiLeadMagnetDeleteLeadMagnetIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.leadMagnetDeleteLeadMagnetIdDelete(requestParameters.leadMagnetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a lead magnet by ID
         * @param {LeadMagnetApiLeadMagnetGetLeadMagnetIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadMagnetGetLeadMagnetIdGet(requestParameters: LeadMagnetApiLeadMagnetGetLeadMagnetIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.leadMagnetGetLeadMagnetIdGet(requestParameters.leadMagnetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all lead magnets
         * @param {LeadMagnetApiLeadMagnetListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadMagnetListGet(requestParameters: LeadMagnetApiLeadMagnetListGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.leadMagnetListGet(requestParameters.search, requestParameters.status, requestParameters.createdBy, requestParameters.assetId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a lead magnet by ID
         * @param {LeadMagnetApiLeadMagnetUpdateLeadMagnetIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadMagnetUpdateLeadMagnetIdPut(requestParameters: LeadMagnetApiLeadMagnetUpdateLeadMagnetIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.leadMagnetUpdateLeadMagnetIdPut(requestParameters.leadMagnetId, requestParameters.leadMagnetUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for leadMagnetCreatePost operation in LeadMagnetApi.
 */
export interface LeadMagnetApiLeadMagnetCreatePostRequest {
    readonly leadMagnetCreate: LeadMagnetCreate
}

/**
 * Request parameters for leadMagnetDeleteLeadMagnetIdDelete operation in LeadMagnetApi.
 */
export interface LeadMagnetApiLeadMagnetDeleteLeadMagnetIdDeleteRequest {
    readonly leadMagnetId: string
}

/**
 * Request parameters for leadMagnetGetLeadMagnetIdGet operation in LeadMagnetApi.
 */
export interface LeadMagnetApiLeadMagnetGetLeadMagnetIdGetRequest {
    readonly leadMagnetId: string
}

/**
 * Request parameters for leadMagnetListGet operation in LeadMagnetApi.
 */
export interface LeadMagnetApiLeadMagnetListGetRequest {
    readonly search?: string | null

    readonly status?: string | null

    readonly createdBy?: string | null

    readonly assetId?: string | null

    readonly limit?: number | null

    readonly offset?: number | null
}

/**
 * Request parameters for leadMagnetUpdateLeadMagnetIdPut operation in LeadMagnetApi.
 */
export interface LeadMagnetApiLeadMagnetUpdateLeadMagnetIdPutRequest {
    readonly leadMagnetId: string

    readonly leadMagnetUpdate: LeadMagnetUpdate
}

/**
 * LeadMagnetApi - object-oriented interface
 */
export class LeadMagnetApi extends BaseAPI {
    /**
     * 
     * @summary Create a new lead magnet
     * @param {LeadMagnetApiLeadMagnetCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leadMagnetCreatePost(requestParameters: LeadMagnetApiLeadMagnetCreatePostRequest, options?: RawAxiosRequestConfig) {
        return LeadMagnetApiFp(this.configuration).leadMagnetCreatePost(requestParameters.leadMagnetCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a lead magnet by ID
     * @param {LeadMagnetApiLeadMagnetDeleteLeadMagnetIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leadMagnetDeleteLeadMagnetIdDelete(requestParameters: LeadMagnetApiLeadMagnetDeleteLeadMagnetIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return LeadMagnetApiFp(this.configuration).leadMagnetDeleteLeadMagnetIdDelete(requestParameters.leadMagnetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a lead magnet by ID
     * @param {LeadMagnetApiLeadMagnetGetLeadMagnetIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leadMagnetGetLeadMagnetIdGet(requestParameters: LeadMagnetApiLeadMagnetGetLeadMagnetIdGetRequest, options?: RawAxiosRequestConfig) {
        return LeadMagnetApiFp(this.configuration).leadMagnetGetLeadMagnetIdGet(requestParameters.leadMagnetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all lead magnets
     * @param {LeadMagnetApiLeadMagnetListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leadMagnetListGet(requestParameters: LeadMagnetApiLeadMagnetListGetRequest = {}, options?: RawAxiosRequestConfig) {
        return LeadMagnetApiFp(this.configuration).leadMagnetListGet(requestParameters.search, requestParameters.status, requestParameters.createdBy, requestParameters.assetId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a lead magnet by ID
     * @param {LeadMagnetApiLeadMagnetUpdateLeadMagnetIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leadMagnetUpdateLeadMagnetIdPut(requestParameters: LeadMagnetApiLeadMagnetUpdateLeadMagnetIdPutRequest, options?: RawAxiosRequestConfig) {
        return LeadMagnetApiFp(this.configuration).leadMagnetUpdateLeadMagnetIdPut(requestParameters.leadMagnetId, requestParameters.leadMagnetUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

